import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { useWindowSize } from '@react-hook/window-size';
import {
  Masonry,
  usePositioner,
  useContainerPosition,
  useResizeObserver,
} from 'masonic';

import FilesMiniMasonryItem from './MasonryItem';

const FilesMiniMasonry = ({
  files,
  filesLastUpdate,
  selectedFiles,
  className,
}) => {
  const photos = files.map(file => (
    {
      file,
      isSelected: !!selectedFiles.find(sf => (sf.uuid === file.uuid)),
    }
  ));

  const containerRef = React.useRef(null);
  const [windowWidth, height] = useWindowSize();
  const { width } = useContainerPosition(containerRef, [
    windowWidth,
    height,
  ]);
  const positioner = usePositioner({ width, columnGutter: 8 });
  const resizeObserver = useResizeObserver(positioner);

  if (photos.length === 0) {
    return null;
  }

  let columnCount = 2;
  if (windowWidth > 576) {
    columnCount = 4;
  }
  if (windowWidth > 992) {
    columnCount = 5;
  }
  if (windowWidth > 1200) {
    columnCount = 6;
  }

  return (
    <div className={classnames('files-masonry', className)}>
      <Masonry
        key={filesLastUpdate}
        className="masonry-grid"
        positioner={positioner}
        resizeObserver={resizeObserver}
        items={photos}
        render={FilesMiniMasonryItem}
        overscanBy="Infinity"
        columnGutter={20}
        columnWidth={200}
        columnCount={columnCount}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  filesLastUpdate: state.Files.lastUpdate,
  selectedFiles: state.Files.selectedFiles,
});

FilesMiniMasonry.propTypes = {
  filesLastUpdate: PropTypes.string.isRequired,
  files: PropTypes.array.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  className: PropTypes.string,
};

FilesMiniMasonry.defaultProps = {
  className: '',
};

export default connect(mapStateToProps)(FilesMiniMasonry);
